var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 521.3 520.7",
    style: {
      enableBackground: "new 0 0 521.3 520.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.cal5{fill:green;}\n\t.cal1{fill:url(#SVGID_2_);}\n\t.cal2{fill:url(#SVGID_3_);}\n\t.cal3{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "_x34_wiOBD.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6344,
    y1: 7.0877,
    x2: 260.6344,
    y2: 515.4675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40C70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#289100"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cal5",
    d: "M362.5,4.8c3,0,6,0,9,0c0.2,0.2,0.4,0.6,0.7,0.7c10.6,2.2,16.9,12.7,16.4,22.1c-0.3,4.8-0.1,9.6,0,14.4 c0,1.8,0.1,3.5,0.2,5.6c2,0,3.7,0,5.3,0c7.1,0,14.3-0.3,21.4,0.2c6.4,0.4,12.9,1.2,19.1,2.7c15.6,3.5,29.6,10.5,42,20.6 c20.3,16.6,33,37.7,37.8,63.5c0.6,3,1.3,6,1.9,9c0,91.8,0,183.6,0,275.5c-0.3,0.6-0.7,1.1-0.8,1.7c-0.8,4.6-1.2,9.2-2.3,13.7 c-6.1,24.4-19,44.4-39,59.6c-19.4,14.8-41.4,21.8-65.8,21.8c-98.3,0-196.6,0-294.9,0c-14.4,0-28.3-2.4-41.7-7.9 c-22.6-9.3-40.1-24.5-52.3-45.6c-9.8-16.9-14.2-35.2-14.2-54.7c0.1-64,0-128.1,0-192.1c0-21.6-0.1-43.2,0.1-64.9 c0-8.3,1.5-16.5,3.7-24.5c6.2-22.7,18.6-41.3,37-55.9c18-14.2,38.5-21.9,61.5-22.6c7.1-0.2,14.3-0.1,21.5-0.1 c1.3,0,2.6-0.2,3.9-0.3c0.1-1.1,0.2-1.9,0.2-2.8c0-6,0-12,0-18c0.1-10.4,5.8-17.9,15.8-20.9c0.4-0.1,0.8-0.5,1.1-0.8c3,0,6,0,9,0 c0.7,0.4,1.3,0.8,2,1.1C168.7,9,174,14.3,175,22.9c0.5,4.8,0.5,9.6,0.6,14.4c0.1,3.3,0,6.6,0,10c56.8,0,113.2,0,169.8,0 c0.1-1.6,0.2-3.1,0.2-4.5c0-5.3-0.1-10.6,0-16c0.4-10.8,6-18,15.2-21.1C361.5,5.6,361.9,5.1,362.5,4.8z M48.2,217.6 c-0.1,1.6-0.3,2.7-0.3,3.8c0,63,0,126.1,0,189.1c0,3.6,0.3,7.3,1.1,10.9c4.9,23.7,19.1,39.6,41.5,48.3c7.3,2.8,15.1,3.5,23,3.5 c98.1-0.1,196.3,0,294.4,0c1.7,0,3.3,0.1,5-0.1c3.3-0.3,6.6-0.4,9.9-1.2c19.8-4.4,34.4-15.8,43.9-33.7c5-9.4,6.8-19.6,6.8-30.2 c-0.1-61.7-0.1-123.4-0.1-185.1c0-6,0.4-5.2-5.5-5.2c-138.2,0-276.5,0-414.7,0C51.6,217.6,50,217.6,48.2,217.6z M48.8,175.3 c1.4,0,3.2,0,5,0c137.9,0,275.7,0,413.6,0c1.2,0,2.3-0.1,3.5,0c2,0.2,2.6-0.8,2.5-2.7c-0.1-7.6,0.1-15.3-0.2-22.9 c-0.1-3.8-0.7-7.6-1.6-11.3c-7-27.5-30.7-48.5-62.2-48.5c-99.1-0.2-198.2-0.1-297.3,0c-4.1,0-8.3,0.4-12.4,1.2 c-10.8,2.1-20.5,6.6-28.9,13.7c-12.7,10.7-20.6,24.4-22.4,40.9c-1,9.5-0.2,19.2-0.2,28.9C48.2,174.7,48.3,174.8,48.8,175.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6236,
    y1: 7.0877,
    x2: 260.6236,
    y2: 515.4675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40C70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#289100"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cal1",
    d: "M260.8,298.8c18.4,0.3,31.9,14.9,31.8,32.1c-0.1,17.8-14.2,31.8-32,31.7c-18.1-0.1-31.9-14.9-31.8-32 C228.8,313,243.3,298.7,260.8,298.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1119,
    y1: 7.0877,
    x2: 154.1119,
    y2: 515.4675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40C70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#289100"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cal2",
    d: "M185.9,330.9c0.6,15.6-12.8,31.9-32.1,31.7c-16.2-0.2-31.5-12.6-31.6-31.9c-0.1-18.9,15.3-32,32-32 C173.3,298.8,186.7,315.1,185.9,330.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.1722,
    y1: 7.0877,
    x2: 367.1722,
    y2: 515.4675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40C70C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#289100"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cal3",
    d: "M335.4,330.7c-0.7-15.9,13-32,31.9-31.9c16.3,0.1,31.6,12.4,31.7,31.7c0.2,19.1-14.9,32-31.8,32.1 C348.2,362.8,334.7,346.5,335.4,330.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarStart);
export default __webpack_public_path__ + "static/media/calendar_start.d37df61984510d379bad1b8369a0de9c.svg";
export { ForwardRef as ReactComponent };